import React from "react";
import { CarIcon, ClockIcon, WalkIcon } from "@kursk/components/ui/icons";
import { InfoBlock } from "@kursk/components/ui/InfoBlock/InfoBlock";
import { formatMinutes } from "@kursk/utils/format";

interface IProp {
  routeType: 'auto' | 'walk';
  duration: number;
}

const routeTypeHash = {
  auto: {
    icon: <CarIcon/>,
    title: 'Автомобильный',
  },
  walk: {
    icon: <WalkIcon/>,
    title: 'Пешеходный'
  }
}

export const RouteInfoBlock = ({ routeType, duration }: IProp) => {
  const items = [
    ...routeTypeHash[routeType] ? [{
      ...routeTypeHash[routeType],
      subTitle: 'Тип маршрута'
    }] : [],
    ...duration ? [{
      icon: <ClockIcon />,
      title: formatMinutes(duration),
      subTitle: 'Время маршрута'
    }] : [],
  ]
  return (
    <InfoBlock items={items} />
  )
}
